import { TripType, VehicleType } from "Types/survey";

type TripTypeData = {
  [key in TripType]: { text: string; icon: string };
};
type VehicleTypeData = {
  [key in VehicleType]: { name: string; icon: string };
};

export const TRIP_TYPES_DATA: TripTypeData = {
  general: { text: "سایر", icon: "" },
  mall: { text: "خرید", icon: "" },
  outdoor: { text: "تفریحی", icon: "" },
  school: { text: "تحصیلی (مدرسه، دانشگاه)", icon: "" },
  sport: { text: "ورزش", icon: "" },
  work: { text: "کاری", icon: "" },
};
export const TRIP_TYPES_DATA2: TripTypeData = {
  work: { text: "کاری", icon: "" },
  sport: { text: "ورزش", icon: "" },
  school: { text: "تحصیلی", icon: "" },
  outdoor: { text: "تفریحی", icon: "" },
  mall: { text: "خرید", icon: "" },
  general: { text: "سایر", icon: "" },
};
export const VEHICLE_TYPES_DATA: VehicleTypeData = {
  bus_minibus: { name: "مینی بوس / اتوبوس", icon: "" },
  bus: { name: "اتوبوس", icon: "" },
  car: { name: "خودرو شخصی", icon: "" },
  metro: { name: "مترو", icon: "" },
  motorcycle: { name: "موتورسیکلت / دوچرخه", icon: "" },
  none: { name: "سایر", icon: "" },
  onlinetaxi: { name: "تاکسی اینترنتی", icon: "" },
  pickupTruck: { name: "وانت", icon: "" },
  service: { name: "سرویس", icon: "" },
  taxi: { name: "تاکسی", icon: "" },
  walking: { name: "پیاده", icon: "" },
};

export const PASSENGER_STATUS = {
  not_contacted: "عدم تماس",
  contacted: "تماس گرفته شده",
  suggested: "مسیر پیشنهاد شده",
  ticket_bought: "خرید بلیط",
};
export const SHOW_TYPES = ["مارکر", "هیت مپ گرادیان", "هیت مپ استیتی"];
